<template>
  <div>
    <Head title="Clientes" />

    <!-- 1. Header & Acciones Principales -->
    <ClientHeader 
      title="Clientes"
      :total-count="stats?.total"
      create-url="/clients/create"
      create-label="Crear Cliente"
      :has-export="true"
      :has-import="true"
      export-excel-url="/clientsReports/excel"
      export-pdf-url="/clientsReports/pdf"
      @open-import="isImportModalOpen = true"
    />

    <!-- 2. Sección de Estadísticas / KPIs -->
    <ClientStats :stats="stats" />

    <!-- 3. Barra de Búsqueda y Filtros Rápidos -->
    <ClientFilters 
      v-model:search="form.search"
      v-model:status="form.status"
    />

    <!-- 4. Tabla y Listado Principal -->
    <ClientTable 
      :clients="clients" 
      @delete="confirmDeleteClient"
    />

    <!-- 5. Modal de Importación Masiva -->
    <ClientImportModal 
      v-if="isImportModalOpen"
      :csrf="csrf"
      @close="isImportModalOpen = false"
    />
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import ClientHeader from './Partials/ClientHeader.vue'
import ClientStats from './Partials/ClientStats.vue'
import ClientFilters from './Partials/ClientFilters.vue'
import ClientTable from './Partials/ClientTable.vue'
import ClientImportModal from './Partials/ClientImportModal.vue'

export default {
  name: 'ClientsIndex',

  components: {
    Head,
    ClientHeader,
    ClientStats,
    ClientFilters,
    ClientTable,
    ClientImportModal,
  },

  layout: Layout,

  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
    clients: {
      type: Object,
      required: true,
    },
    stats: {
      type: Object,
      default: () => null,
    },
    account: {
      type: Object,
      default: () => ({}),
    },
    csrf: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      form: {
        search: this.filters.search || '',
        status: this.filters.status || '',
      },
      isImportModalOpen: false,
    }
  },

  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/clients', pickBy(this.form), { 
          preserveState: true,
          replace: true,
        })
      }, 300),
    },
  },

  methods: {
    confirmDeleteClient(client) {
      if (confirm(`¿Está seguro que desea eliminar al cliente "${client.name}"?`)) {
        this.$inertia.delete(`/clients/${client.id}`)
      }
    },
  },
}
</script>
